module.exports = __webpack_public_path__ + "svg/gemini.svg?b508c08826f90994192022311608770f";